module.exports = {
	baseURL: '/api'
}



// WEBPACK FOOTER //
// ./src/utils/env.js